// extracted by css-extract-rspack-plugin
export default {"chipsContainer":"chipsContainer-GOgGqr","placeholder":"placeholder-fj9d6i text-body-base"};